import React, { useState, useEffect } from "react";
import { Button } from "@material-ui/core";
import firebase from "../../helpers/firebase";
import { updateStatus } from "../../helpers/firebaseCRUD";
import { localStore } from "../../helpers/localStorage";
import { useHistory } from "react-router-dom";

function PollingResponses() {
	const history = useHistory();
	const db = firebase.firestore();
	const sessionId = localStore.getSession();
	const [answersSubmitted, setAnswersSubmitted] = useState("0");
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setLoading(false);
		try {
			if (sessionId) {
				watchResponses();
			}
		} catch (err) {
			console.log(err);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const watchResponses = async () => {
		let doc = db.collection("sessions").doc(sessionId);
		await updateStatus("TEST_STARTED");

		doc.collection("answers").onSnapshot((doc) => {
			if (doc) {
				setAnswersSubmitted(doc.docs.length);
			}
		});
	};

	const handleEndExercise = async () => {
		setLoading(true);
		await updateStatus("TEST_END");
		history.push("/instructor/view_answers");
	};

	return (
		<>
			<div style={{ margin: "auto" }} />
			<div>
				<span className="text-medium d-block" style={{ marginBottom: "10px" }}>
					polling...
				</span>
				<h1 style={{ marginBottom: "6px", marginTop: "0px" }}>
					{answersSubmitted}
				</h1>
				<span className="text-medium d-block" style={{ marginBottom: "40px" }}>
					responses <br /> submitted
				</span>
				<Button
					className="CustomButton w100"
					variant="contained"
					size="large"
					onClick={handleEndExercise}
					disabled={loading}
				>
					End Exercise
				</Button>
			</div>
			<div style={{ margin: "auto" }} />
		</>
	);
}

export default PollingResponses;
